import { randomUUID as uuidv4 } from 'expo-crypto';

import type {
  ICartEntryOffer,
  ICartEntryReward,
  ICreateCartEntryOfferParams,
  ICreateCartEntryOptions,
  ICreateCartEntryParams,
  ICreateCartEntryRewardParams,
  IEngineRewardCartIncentive,
  ILegacyCartEntry,
  IOfferCartIncentive,
  IRewardCartIncentive,
} from './types';
import { ICartEntryType, isEngineReward, isOffer, isReward } from './types';

// helper functions
const isRewardEntryParam = (
  item: any
): item is { reward: IRewardCartIncentive; engineReward: IEngineRewardCartIncentive } =>
  isReward(item?.reward) && isEngineReward(item?.engineReward);
const isServiceRewardEntryParam = (
  item: any
): item is Extract<ICreateCartEntryRewardParams, { source: 'service' }> =>
  item?.source === 'service' && typeof item?.reward?.id === 'string';
const isOfferEntryParam = (item: any): item is { offer: IOfferCartIncentive } =>
  isOffer(item?.offer);

export function createCartEntry(
  item: ICreateCartEntryRewardParams,
  options?: ICreateCartEntryOptions
): ICartEntryReward;
export function createCartEntry(
  item: ICreateCartEntryOfferParams,
  options?: ICreateCartEntryOptions
): ICartEntryOffer;
export function createCartEntry(
  item: ICreateCartEntryParams,
  options?: ICreateCartEntryOptions
): ILegacyCartEntry | null;
export function createCartEntry(
  item: ICreateCartEntryParams,
  { initialQuantity = 1 }: ICreateCartEntryOptions = {}
): ILegacyCartEntry | null {
  let partialCartEntry: ILegacyCartEntry | null = null;

  if (isOfferEntryParam(item)) {
    partialCartEntry = {
      referenceId: uuidv4(),
      quantity: initialQuantity,
      type: ICartEntryType.OFFER,
      details: { offer: item.offer },
    };
  } else if (isServiceRewardEntryParam(item)) {
    partialCartEntry = {
      referenceId: uuidv4(),
      quantity: initialQuantity,
      type: ICartEntryType.REWARD,
      details: { source: 'service', reward: item.reward },
    };
  } else if (isRewardEntryParam(item)) {
    partialCartEntry = {
      referenceId: uuidv4(),
      quantity: initialQuantity,
      type: ICartEntryType.REWARD,
      details: { reward: item.reward, engineReward: item.engineReward },
    };
  }

  return partialCartEntry;
}
